<template>
  <header class="main-header">
    <current-timezone></current-timezone>
    <voxy-organization-filter></voxy-organization-filter>
    <conversations-button></conversations-button>
  </header>
</template>

<script>
import CurrentTimezone from '@/components/CurrentTimezone';
import VoxyOrganizationFilter from '@/components/voxy/VoxyOrganizationFilter';
import ConversationsButton from '@/components/ConversationsButton';

export default {
  name: 'MainHeader',

  components: {
    CurrentTimezone,
    VoxyOrganizationFilter,
    ConversationsButton,
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/mixins';
@import '~styles/tools/variables';

.main-header {
  @include container();

  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  z-index: $zindex-header;
  height: $main-header-height;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: #313131;
}
</style>
